export default "__VITE_ASSET__CsJHJr9W__"